// extracted by mini-css-extract-plugin
module.exports = {"title":"Title_title__KaSWf","title_line":"Title_title_line__Zj_ND"};